<atlas-app-bar class="dsp-header-panel" [showLogo]="true" [logoIcon]="'Marsh-Logo'" [logoCollection]="'brand-logos'"
  [appName]="'Investor Portal'" [showAppNameDivider]="true" [showAvatar]="false" [logoSize]="iconSize"
  (logoClick)="onLogoClick()" (appNameClick)="onAppNameClick()">

  <!-- Projected actions in the appBarActions slot -->
  <div appBarActions class="dsp-app-bar-actions">
    <!-- Country Drop Down -->
    <ng-container *ngIf="superadmin$ | async">
      <atlas-field-select class="show-for-medium" [style.--radius-xsmall]="'4px'" *ngIf="superadmin$ | async"
        [size]="countryDropDownSize" [fullWidth]="false" [options]="options" [(ngModel)]="selectedCountry"
        (valueChange)='onChangeCountry($event)' [clearable]="false">
      </atlas-field-select>
    </ng-container>

    <!-- Admin Site visit Link -->
    <ng-container
      *ngIf="(admin$ | async) && !(((user$ | async)?.role === 'consultant') && ((user$ | async)?.type === 'external'))">
      <atlas-icon-button class="show-for-medium" [icon]="'settings'" [size]="'medium'" [alt]="'Admin'"
        [customClass]="(router.url.includes('/administration') ? 'dsp-active-icon ' : '') + 'dsp-header-icon-button'"
        (onClick)="router.navigate(['/administration'])" [haloTooltipWithArrow]="true" [haloTooltip]="'Administration'"
        [haloTooltipPosition]="'bottom'" [haloTooltipShowDelay]="100">
      </atlas-icon-button>
    </ng-container>

    <!-- Notifications -->
    <ng-container *ngIf="(logged$ | async) && (user$ | async)">
      <atlas-dropdown id="notification-id-pendo" class="notification show-for-medium"
        #notificationDropdown="atlasDropdown" [triggerType]="dropdownTriggerTypeIconButton" [fill]="true"
        [placement]="'bottom-end'" [icon]="'icon-notification-24'" [iconSize]="'large'" [iconColor]="'neutral'"
        [iconButtonCustomClass]="'dsp-header-icon-button'" [haloTooltipWithArrow]="true" [haloTooltip]="'Notifications'"
        [haloTooltipPosition]="'bottom'">
        <atlas-menu class="dsp-notification-list">
          <atlas-list>
            <atlas-list-item *ngFor="let item of notifications$ | async; let index = index" [item]="item"
              (itemSelected)="onSelect(item)" (click)="notificationDropdown.menu?.closeMenu($event)">
              <div class="mos-u-divider--bottom-md"
                [ngClass]="{ 'dsp-read-notification': item.read, 'dsp-active-notification': !item.read}"
                (click)="markAsRead(item)" [haloTooltipWithArrow]="true" [haloTooltip]="ROW_MAP[item.type](item)"
                haloTooltipPosition="left" haloTooltipShowDelay="300">
                <span>
                  <span class="dsp-notification-title typographyStyles-body-small">
                    <!-- <atlas-icon icon="{{ICON_MAP[item.type]}}" size="large" color="primary" alt="Thumbs up!"></atlas-icon> -->
                    <atlas-icon [icon]="'icon-mail-24'" [size]="'large'" [color]="'primary'"
                      [alt]="'Thumbs up!'"></atlas-icon>

                    {{HEADER_ROW_MAP[item.type](item)}}
                    &middot;
                  </span>
                  <span class="notification-date">
                    {{item.date | date: 'dd-MMM-yyyy'}}
                  </span>
                  <span class="notification-item typographyStyles-body-small">{{ROW_MAP[item.type](item)}}</span>
                </span>
              </div>
            </atlas-list-item>
            <atlas-list-item (click)="notificationDropdown.menu?.closeMenu($event)">
              <div class="mos-u-divider--bottom-md" class="dsp-read-notification"
                (click)="markAsRead({type: 'settings'})" [haloTooltipWithArrow]="true"
                [haloTooltip]="'Go to Notification Settings'">
                <span class="">
                  <span class="notification-item typographyStyles-body-small">Notification
                    Settings</span>
                </span>
              </div>
            </atlas-list-item>
          </atlas-list>
        </atlas-menu>
      </atlas-dropdown>
    </ng-container>

    <!-- User Avatar & it's dropdown -->
    <ng-container *ngIf="(logged$ | async) && (user$ | async)">
      <atlas-dropdown id="user-avatar-pendo-id" class="user-avatar" #userDropdown="atlasDropdown"
        [triggerType]="dropdownTriggerTypeCustom" [placement]="'bottom-end'">
        <atlas-avatar id="user-avatar-pendo" class="dsp-user-avatar-trigger" dropdownTrigger
          *ngIf="!(user$ | async)?.profileImageId" [imgAlt]="'Profile Image'">
          {{(user$ | async)?.initials}}
        </atlas-avatar>
        <atlas-avatar class="dsp-user-avatar-trigger" dropdownTrigger
          *ngIf="(user$ | async)?.profileImageId && !imageLoadFailed" [imgSrc]="imageUrl" [imgAlt]="'Profile Image'">
        </atlas-avatar>
        <atlas-avatar class="dsp-user-avatar-trigger" dropdownTrigger
          *ngIf="(user$ | async)?.profileImageId && imageLoadFailed" [imgAlt]="'Profile Image'">
          {{(user$ | async)?.initials}}
        </atlas-avatar>
        <atlas-menu>
          <atlas-list>
            <!-- <atlas-list-item> -->
            <div
              class="atlas-list-item typographyStyles-body-medium list-item-brand list-item--level-null list-item-size-default">
              <div class="row expanded collapse">
                <div class="columns shrink mos-u-align-center--vertical">
                  <atlas-avatar *ngIf="!(user$ | async)?.profileImageId" [imgAlt]="'Profile Image'">
                    {{(user$ | async)?.initials}}
                  </atlas-avatar>
                  <atlas-avatar *ngIf="(user$ | async)?.profileImageId && !imageLoadFailed" [imgSrc]="imageUrl"
                    [imgAlt]="'Profile Image'">
                  </atlas-avatar>
                  <atlas-avatar *ngIf="(user$ | async)?.profileImageId && imageLoadFailed" [imgAlt]="'Profile Image'">
                    {{(user$ | async)?.initials}}
                  </atlas-avatar>
                </div>
                <div class="columns mos-u-align-center--vertical" style="padding-left: 15px !important;">
                  <div style="color: var(--semanticColor-text-primary)" class="typographyStyles-body-large">
                    {{(user$ | async)?.fullName}}
                  </div>
                </div>
              </div>
              <div *ngIf="!(admin$ | async) || !(superadmin$ | async)" class="row expanded collapse">
                <div class="columns">
                  <div style="color: var(--semanticColor-text-secondary)" class="typographyStyles-body-small">
                    {{(user$ | async)?.org?.name}}
                  </div>
                </div>
              </div>
            </div>
          </atlas-list>
          <!-- <hr class="app-bar-logo-line" /> -->
          <atlas-list>
            <atlas-list-item (click)="userDropdown.menu?.closeMenu($event); router.navigate(['/profile'])">
              View My Profile
            </atlas-list-item>
            <atlas-list-item (click)="userDropdown.menu?.closeMenu($event); logout()">Logout</atlas-list-item>
          </atlas-list>
          <!-- <atlas-menu-item label="View My Profile" (itemSelected)="router.navigate(['/profile'])"></atlas-menu-item>
          <atlas-menu-item label="Logout" (itemSelected)="logout()"></atlas-menu-item> -->
        </atlas-menu>
      </atlas-dropdown>
    </ng-container>
  </div>

</atlas-app-bar>

<dsp-logout #logoutComponent *ngIf="logged$ | async"></dsp-logout>